<template>
	<div id="proyecto">
		<div class="card">
			<div class="card-header">
				<h3>Agregar Proyecto</h3>
			</div>

			<div class="card-body row">
				<div class="col-md-4 mb-3 text-left">
          <label>Proyecto:</label>
          <input class="form-control" type="text" placeholder="Proyecto" v-model="nombreProyecto">
        </div>

        <div class="col-md-4 mb-3 text-left">
          <label>Cliente:</label>
          <input class="form-control" type="text" placeholder="Cliente" v-model="nombreCliente">
        </div>

        <div class="col-md-4 mb-3 p-4">
          <button class="btn btn-success" @click="agregarProyecto">Agregar</button>
          <button class="btn btn-danger" @click="cancelarProyecto">Cancelar</button>
        </div>
			</div>
		</div>
	</div>
</template>

<script>
  import { bus } from '../main';
	import axios from 'axios';
	import Toastr from 'toastr';
  import Store from '../store/index';

	export default {
		name: 'Proyecto',
		data () {
			return {
				nombreProyecto: '',
				nombreCliente: ''
			}
		},
		methods: {
			// Agrega el proyecto insertado
			agregarProyecto: function() {
				var self = this;
				var servicio = 'AgregarProyecto';
				var exito = function (response) {
					console.log(response.data);
					if (response.data.Msg == 'Error') {
						Toastr.error("Hubo un problema al tratar de insertar el proyecto.");
					} else if (response.data.Msg == 'Clave incorrecta') {
						Toastr.info("Debe ingresar una clave de usuario válida.");
					} else {
						Toastr.success("Proyecto agregado con éxito.");
					}
				};

				var error = function (error) {
					Toastr.error("Hubo un problema al tratar de insertar el proyecto.");
				};

				let p = {
					clave: Store.state.clave,
					proyecto: self.nombreProyecto,
					cliente: self.nombreCliente
				};

				if ((p.proyecto != '') && (p.cliente != '')) {					
					self.servicioPost(servicio, p, exito, error);
				} else {
					Toastr.info("Es necesario agregar un nombre de cliente y de proyecto.");
				}
			},

			// Cierra la sección de agregar proyecto
			cancelarProyecto: function() {
				this.nombreProyecto = '';
				this.nombreCliente = '';

				bus.$emit('AgregarProyecto');
			},

			// Procesa un servicio web de tipo GET
      servicioGet: function(servicio, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.get(url, {})
        .then(exito)
        .catch(error);
      },

      // Procesa un servicio web de tipo POST
      servicioPost: function(servicio, parametro, exito, error) {
        var url = 'http://tiempo.getpost.com.mx/WS/Timer' + servicio + '.php';

        axios.post(url, parametro)
        .then(exito)
        .catch(error);
      }
		}
	}
</script>

<style scoped>
	
</style>


// WEBPACK FOOTER //
// src/components/Proyecto.vue